<script>
import axios from "axios";

export default {
    name: "RetailerSearchInput",
    emits: ['updated-position', 'updated-query'],

    data() {
        return {
            vModel : '',
            xhrRequest : false
        }
    },

    props : {
        query : {
            type: String,
            default: '',
        }
    },

    created() {
        this.vModel = this.query;
    },

    watch: {
      query(value) {
          console.log('new query '+value + ' / ' +this.vModel);
          if (value != this.vModel) {
            this.vModel = value;
            this.maybeTriggerZipcodeSearch();
          }
      }
    },

    methods: {
        maybeTriggerZipcodeSearch() {
            // console.log('maybeTriggerZipcodeSearch()');
            const query = this.vModel;
            const zipcode = parseInt(query);

            this.$emit('updated-query', query);

            // search by zipcode
            if (query.length === 4 && Number.isInteger(zipcode) === true && this.getXhrRequest() === false) {
                this.getPositionByZipcode(query);
            }
        },

        getPositionByZipcode(zipcode)
        {
            // console.log(`getPositionByZipcode(${zipcode})`);

            const url = `/actions/gs/zipcode/geoposition`;
            const queryArgs = {
                zipcode : zipcode,
            }
            this.rest(url, queryArgs, 'getPositionByZipcode__callback');
        },

        getPositionByZipcode__callback(response)
        {
            // console.log('getPositionByZipcode__callback()');

            const data = response.data ?? [];

            // console.log('🫣 api response')
            // console.log(data)
            if (typeof data === 'object') {
                // console.log('trigger update event')
                this.$emit('updated-position', data.lat, data.lon);
            }

            this.setXhrRequest(false);
        },

        rest(endpoint, queryArgs, callback)
        {
            let queryString = "";
            for (let i in queryArgs) {
                queryString += i + "=" + queryArgs[i]+"&";
            }
            const url = endpoint + "?" + queryString;

            axios.get(url)
                .then(this[callback])
                .catch(function (error) {});
        },

        getXhrRequest(value) {
            return this.xhrRequest;
        },

        setXhrRequest(value) {
            this.xhrRequest = value;
        }
    }
}
</script>

<template>
    <div class="retailer-search__input retailer-search__input--inline">
        <input type="text" placeholder="Skriv inn postnummer" class="input" name="query" @keyup="maybeTriggerZipcodeSearch" v-model="vModel">
        <button type="submit" aria-label="Søk" class="btn">
            <span class="d-none">Søk</span>
            <span class="svg-icon retailer-search__ux-icon"><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" class="slim"><path d="M11.7451 10.8377H10.9974L10.7335 10.5739C11.833 9.25451 12.4487 7.45138 12.0969 5.56029C11.6571 2.96555 9.50214 0.854571 6.86342 0.54672C2.90534 0.0629535 -0.437046 3.40534 0.0467196 7.36342C0.354571 10.0021 2.46555 12.1571 5.06029 12.5969C6.95138 12.9487 8.75451 12.333 10.0739 11.2335L10.3377 11.4974V12.2451L14.2958 16.2031C14.6916 16.599 15.3073 16.599 15.7031 16.2031C16.099 15.8513 16.099 15.1916 15.7031 14.8398L11.7451 10.8377ZM6.11578 10.8377C3.78491 10.8377 1.89383 8.94666 1.89383 6.61578C1.89383 4.28491 3.78491 2.39383 6.11578 2.39383C8.44666 2.39383 10.3377 4.28491 10.3377 6.61578C10.3377 8.94666 8.44666 10.8377 6.11578 10.8377Z" fill="#222E49"></path></svg></span>
        </button>
    </div>
</template>

